export const DarkColor = "#19202e";
export const MediumColor =  "#33435c";
export const SoftColor = "#F9F6EF";
